import css from './index.module.scss';
import EFLoadingIcon from '@/components/UI/svg/Icons/EFLoadingIcon';

export default function Loading({ wrapperClassName = '' }: any) {
    return (
        <div className={`${css.loadingMask} ${wrapperClassName}`}>
            <span className="loading-icon">
                <EFLoadingIcon />
            </span>
        </div>
    );
}
